var _path, _g, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilePpt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.75 3C5.92157 3 5.25 3.67157 5.25 4.5V19.5C5.25 20.3284 5.92157 21 6.75 21H17.25C18.0784 21 18.75 20.3284 18.75 19.5V8.25L13.5 3H6.75Z",
    fill: "#FFC06E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_7789_76267)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5 8.25V3L18.75 8.25H13.5Z",
    fill: "#D47800"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66631 17.7852C8.47734 17.7852 8.32354 17.6313 8.32354 17.4424C8.32354 17.2578 8.47734 17.104 8.66631 17.104C8.84648 17.104 9.00469 17.2578 9.00469 17.4424C9.00469 17.6313 8.84648 17.7852 8.66631 17.7852ZM9.43271 18.6465V15.3638H9.98203V15.7549H10.0172C10.1051 15.5835 10.2809 15.333 10.7027 15.333C11.2521 15.333 11.6871 15.7637 11.6871 16.5591C11.6871 17.3457 11.2652 17.7939 10.7027 17.7939C10.2896 17.7939 10.1051 17.5479 10.0172 17.3721H9.99521V18.6465H9.43271ZM9.98203 16.5547C9.98203 17.0205 10.1842 17.3325 10.5489 17.3325C10.9181 17.3325 11.1158 17.0073 11.1158 16.5547C11.1158 16.1108 10.9225 15.79 10.5489 15.79C10.1842 15.79 9.98203 16.0933 9.98203 16.5547ZM12.0141 18.6465V15.3638H12.5634V15.7549H12.5985C12.6864 15.5835 12.8622 15.333 13.2841 15.333C13.8334 15.333 14.2685 15.7637 14.2685 16.5591C14.2685 17.3457 13.8466 17.7939 13.2841 17.7939C12.871 17.7939 12.6864 17.5479 12.5985 17.3721H12.5766V18.6465H12.0141ZM12.5634 16.5547C12.5634 17.0205 12.7655 17.3325 13.1303 17.3325C13.4994 17.3325 13.6972 17.0073 13.6972 16.5547C13.6972 16.1108 13.5038 15.79 13.1303 15.79C12.7655 15.79 12.5634 16.0933 12.5634 16.5547ZM15.7863 15.3638V15.7944H15.3161V17.0337C15.3161 17.2622 15.4304 17.3105 15.571 17.3105C15.6369 17.3105 15.7468 17.3062 15.8171 17.3018V17.7588C15.7512 17.772 15.6413 17.7808 15.5007 17.7808C15.0788 17.7808 14.7536 17.5742 14.758 17.126V15.7944H14.4152V15.3638H14.758V14.7925H15.3161V15.3638H15.7863Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_7789_76267",
    x: 10.5,
    y: 1.5,
    width: 11.25,
    height: 11.25,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.20694 0 0 0 0 0.51735 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7789_76267"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7789_76267",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilePpt);
export default __webpack_public_path__ + "static/media/file-ppt.ffdc81888f87182f091159682c86a457.svg";
export { ForwardRef as ReactComponent };